import React, { useEffect } from 'react';
    import './Notification.css';

    const META = {
      success: { icon: 'check-lg', title: 'Terminé' },
      error: { icon: 'exclamation-lg', title: 'Action impossible' },
      warning: { icon: 'exclamation-triangle', title: 'Attention' },
      info: { icon: 'info-lg', title: 'Information' },
    };

    function Toast({ notification, onRemove }) {
      const type = META[notification.type] ? notification.type : 'info';
      const meta = META[type];
      const duration = Number(notification.duration) || (type === 'error' ? 6500 : 4500);

      useEffect(() => {
        const timer = window.setTimeout(() => onRemove(notification.id), duration);
        return () => window.clearTimeout(timer);
      }, [duration, notification.id, onRemove]);

      return (
        <article className={'erp-toast erp-toast--' + type} role={type === 'error' || type === 'warning' ? 'alert' : 'status'}>
          <span className="erp-toast__icon" aria-hidden="true"><i className={'bi bi-' + meta.icon} /></span>
          <div className="erp-toast__content">
            <strong>{notification.title || meta.title}</strong>
            <p>{notification.message}</p>
            {/* Action optionnelle (ex. « Ouvrir la facture ») : un seul geste,
                le toast se ferme en l'exécutant. */}
            {notification.action?.label && typeof notification.action.onClick === 'function' && (
              <button type="button" className="erp-toast__action"
                onClick={() => { onRemove(notification.id); notification.action.onClick(); }}>
                {notification.action.label} <i className="bi bi-arrow-right" />
              </button>
            )}
          </div>
          <button type="button" className="erp-toast__close" onClick={() => onRemove(notification.id)} aria-label="Fermer la notification"><i className="bi bi-x-lg" /></button>
          <span className="erp-toast__timer" style={{ '--toast-duration': duration + 'ms' }} aria-hidden="true" />
        </article>
      );
    }

    export default function Notification({ notifications = [], removeNotification }) {
      if (!notifications.length) return null;
      return <div className="erp-toast-region" aria-live="polite" aria-atomic="false">{notifications.map(notification => <Toast key={notification.id} notification={notification} onRemove={removeNotification} />)}</div>;
    }
    